import * as React from 'react';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Chip from '../../../components/Chip';
import EditRewardsModal from '../../../components/EditRewardsModal';
import { LevelRewardInput } from '../../../../../../__gqltypes__';
import { EditableReward } from '../utils';

type Props = {
  rewards: EditableReward[];
  onChange: (rewards: EditableReward[]) => void;
  centered?: boolean;
};

// Reuses the shared liveops reward editor: chips list + EditRewardsModal (no new reward picker)
const RedeemCodeRewardsEditor = ({ rewards, onChange, centered = false }: Props) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [editedIndex, setEditedIndex] = useState<number | null>(null);

  const handleOpenAdd = () => {
    setEditedIndex(null);
    setShowEditModal(true);
  };

  const handleOpenEdit = (index: number) => {
    setEditedIndex(index);
    setShowEditModal(true);
  };

  const handleSave = (newReward: LevelRewardInput) => {
    setShowEditModal(false);
    if (editedIndex === null) {
      onChange([...rewards, newReward]);
    } else {
      onChange(rewards.map((reward, index) => (index === editedIndex ? newReward : reward)));
    }
  };

  const handleDelete = (index: number) => {
    onChange(rewards.filter((_reward, i) => i !== index));
  };

  return (
    <fieldset className={`border rounded bg-light p-3 mb-3${centered ? ' text-center' : ''}`}>
      <legend className="w-auto px-2 h6 mb-0 font-weight-bold">
        <i className="fas fa-gift mr-2 text-success" />
        Rewards
      </legend>
      <div className={`d-flex flex-wrap align-items-center${centered ? ' justify-content-center' : ''}`}>
        {rewards.map((reward, index) => (
          <Chip
            // eslint-disable-next-line react/no-array-index-key
            key={`${reward.type}-${reward.itemId ?? ''}-${index}`}
            reward={reward}
            canDelete
            btnAction={() => handleDelete(index)}
            globalAction={() => handleOpenEdit(index)}
          />
        ))}
        <Button variant="success" size="sm" className="my-1" onClick={handleOpenAdd}>
          <i className="fas fa-plus mr-2" />
          Add reward
        </Button>
      </div>
      {rewards.length === 0 && <Form.Text className="text-danger">At least one reward is required.</Form.Text>}
      <EditRewardsModal
        show={showEditModal}
        isEdit={editedIndex !== null}
        tier={null}
        level={null}
        reward={editedIndex !== null ? rewards[editedIndex] : null}
        handleSave={handleSave}
        handleClose={() => setShowEditModal(false)}
        disableCurrencySpecialEvent
        disableMonthlyBuff
      />
    </fieldset>
  );
};

export default RedeemCodeRewardsEditor;
